import React, {Fragment, useRef, useState, useEffect} from 'react';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import TextField from '@material-ui/core/TextField';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import {Loader} from '../../../../../components'
import { Field, Form } from 'react-final-form';
import arrayMutators from 'final-form-arrays';
import Timeline from './Timeline';
import Categorize from './Categorize';
import Scorecard from './Scorecard';
import Task_view from './Task_View';
import Display from './Display';
import axios from 'axios';
import { connect } from 'react-redux';

function Data(props){
  let form_props_ref=useRef();
  let call_phone=useRef();
  let email=useRef();
  let goToNumber=useRef();
  let write_note=useRef();
  let send_message=useRef();
  let schedule_task=useRef();
  let schedule_meeting=useRef();
  let filterOnContact=useRef();
  let filterOnDeal=useRef();
  let companies_length=useRef(0);
  let reset_bottom_bar=useRef();
  let refresh_iframes=useRef(false);
  let last_current_company=useRef(undefined);
  let openCmapFunction=useRef();
  const[refresh, setRefresh]=useState(0);
  const[e_interval, setEInterval]=useState();
  let last_company_extension=useRef();
  let reset_index=useRef(false);
  let setAddOnMarketing=useRef(()=>{});

  let pathname=window.location.pathname; let filter=undefined; let entity='prospects'; let ff=pathname.split('/f/'); console.log(ff, 'FFFFFFFF'); if(ff.length>1){filter=atob(decodeURIComponent(ff[1].split('/')[0])); console.log(filter, 'FILTERRR');if(filter!=undefined){filter=JSON.parse(filter); if(filter.entity!=undefined){entity=filter.entity;}}}
  if(props.current_list.block_iframe==true){refresh_iframes.current=true;}
  let force_refresh_iframes=false; if(props.current_list.ids.length>0 && refresh_iframes.current==true && props.current_list.block_iframe==false){force_refresh_iframes=true;}
  //const[dataIndex, setDataIndexState]=useState(0);

  let dataIndex=props.current_list.current_index - ((props.current_list.start_page - 1)*props.current_list.rowsPerPage);


    function setData(d, refresh_iframes=false){
      let c=undefined; if(d!=undefined){c=d.companies}
      if(c!=undefined){
        let cs=[];
        for(let ccc of c){cs.push(checkListingDomain(ccc));}
        c=cs;
      }
      console.log('FROM SET DATA', c);
      props.setIframeData(c, refresh_iframes);
      setDataState(d);
    }

    function checkListingDomain(ccc){if(ccc==undefined || props.workspace_data==undefined){return undefined;} if(ccc.domain_id==null && ccc.company_listing_websites.length>0){for(let www of props.workspace_data.workspace_listing_websites){if(www.id==ccc.company_listing_websites[0].workspace_listing_website_id){ccc.domain_id=www.domain_id;}}} return ccc;}
    function setDataIndexState(n){props.modify_index_companies({current_index:n}); let url=window.location.pathname; let parts=url.split('/view/'); let start=parts[0]+'/view/'; let end=''; let i=0; for(let p of parts[1].split('/')){if(i>0){end+='/'+p;} i+=1;} url=start+(n+1)+end; props.history.push(url);}



    function setDataIndex(i, final=false){
      form_props_ref.current.form.setConfig('keepDirtyOnReinitialize', false);
      form_props_ref.current.form.reset();
      let index=(final==true)?i:(i+((props.current_list.start_page - 1)*props.current_list.rowsPerPage))
      setDataIndexState(index);
      if(dataIndex!=i+1 && reset_bottom_bar.current!=undefined){reset_bottom_bar.current();}
      props.setIframeIndex(index);
    }

    let list=undefined; let companies=[]; let company=undefined;
    if(props.current_list.ids.length>0){
      reset_index.current=false;
      list=props.current_list;
      for(let c_id of list.ids){let x=undefined; if(props.tasks[c_id]!=undefined){x=props.companies[props.tasks[c_id].company_id];}else{x=props.companies[c_id];}; x=JSON.parse(JSON.stringify(x)); if(x.company_id!=undefined){x.id=x.company_id;} companies.push(checkListingDomain(x));}
      if(force_refresh_iframes==true){refresh_iframes.current=false}
      companies=JSON.parse(JSON.stringify(companies));
      console.log('SET COMPANIES', companies);
      props.setIframeData(companies, (force_refresh_iframes==true)?true:false);
      if(force_refresh_iframes==true){props.setIframeIndex(0);}
      if(companies_length.current!=companies.length){companies_length.current=companies.length; props.setIframeIndex(props.current_list.current_index);}
      if(list.ids.length==0){setEmpty(true);}
      if(props.tasks[list.ids[dataIndex]]!=undefined){company=JSON.parse(JSON.stringify(props.companies[props.tasks[list.ids[dataIndex]].company_id])); company.task_id=list.ids[dataIndex]}else if(props.companies[list.ids[dataIndex]]!=undefined){company=JSON.parse(JSON.stringify(props.companies[list.ids[dataIndex]]));}
      if(company!=undefined && company.company_id!=undefined && company.company_id!=company.id){company.id=company.company_id;}
      if(props.lists!=undefined){
        if(company==undefined && props.company_loading==false){
          //goToNumber.current(1);
        }
        else{
          company.list=(company.list_id!=undefined)?props.lists[company.list_id]:undefined;
          if(last_current_company.current!=company.id){document.getElementById('current_company').innerText=JSON.stringify(company); last_current_company.current=company.id;}
    }}}

    if(company!=undefined && props.workspace_data!=undefined){for(let f of company.company_fields){for(let wf of props.workspace_data.workspace_fields){if((wf.data_type==3 || wf.data_type==6) && wf.id==f.workspace_field_id && Array.isArray(f.value)==false){try{f.value=JSON.parse(f.value)}catch(e){f.value=[f.value];}}}}}
    if(company!=undefined){company=JSON.parse(JSON.stringify(company));}

    useEffect(()=>{
      console.log('USE EFFECT DT');
      if(props.current_list.current_index!=(Number(props.match.params.company) - 1)){setDataIndexState(Number(props.match.params.company) -1);}
    },[]);

    //dataIndex is different from current_index. Current index is the actual one. Data index is index within the loaded results.
    if(props.current_list.start_page!=undefined){
      if(props.current_list.requested_pages.includes(props.current_list.end_page+1)==false && props.current_list.ids[dataIndex+10]==undefined && (props.current_list.current_index+10)<(props.current_list.total-1) && props.current_list.end_page!=undefined){if(reset_index.current==true){reset_index.current=false; window.location.href='/';}else{reset_index.current=true;} console.log('MORE'); props.index_companies({...props.current_list, page:props.current_list.end_page+1});}
      if(props.current_list.start_page!=1 && props.current_list.requested_pages.includes(props.current_list.start_page-1)==false && props.current_list.ids[dataIndex-10]==undefined && (props.current_list.current_index-10)>0 && props.current_list.start_page!=undefined){if(reset_index.current==true){reset_index.current=false; window.location.href='/';}else{reset_index.current=true;} console.log('LESS'); props.index_companies({...props.current_list, page:props.current_list.start_page-1});}
    }

    function onSubmit(params){
      let update=false; for(let key in params){if(key=='company_fields' || key=='company_decisions'){let i=0; for(let x of params[key]){for(let k in x){if(company[key][i]==undefined || x[k]!=company[key][i][k]){update=true;}} i+=1;}}}
      if(update==true){props.updateCompany(params.id, {id:params.id, list_id:params.list_id, company_fields:params.company_fields, company_decisions:params.company_decisions}, company);}
    }

    if((last_company_extension.current==undefined && company!=undefined) || (last_company_extension.current!=undefined && company!=undefined && last_company_extension.current.id!=company.id)){
      if(e_interval!=undefined){window.clearInterval(e_interval);}
      let extension_interval=window.setInterval(function(){
        let spec=document.getElementById('extension_refresh_company');
        if(spec!=null && spec.innerText==='refresh'){
          console.log('EXTENSION REFRESH');
            spec.innerText='false';
            let id=company.id; if(company.company_id!=undefined){id=company.company_id;}
            props.getCompany({query:'?id='+id});
          }
      }, 200);
      setEInterval(extension_interval);
      last_company_extension.current=company;
    }


    function openDeal(deal_id){
      if(openCmapFunction.current!=undefined){openCmapFunction.current('deals', deal_id);}else{console.log('UNDEFINED CMAP FUNC');}
    }

    if(props.workspace==undefined){return null;}

    let prospectsafari_email_enrichment=undefined;
    if(props.workspace.active_subscription!=undefined && props.subscriptions!=undefined){
    for(let ae of props.workspace.active_subscription.active_subscription_extras){
      for(let s of props.subscriptions){
        if(ae.prospect_safari_service_id==s.id && s.recognise=='EMAIL_ENRICHMENT'){
          for(let uw of ae.user_workspaces){if(uw.id==props.me.user_workspace_id){console.log('THREE'); prospectsafari_email_enrichment=s;break;}}
        }
      }
    }if(prospectsafari_email_enrichment==undefined && props.email_enrichment!=undefined && props.email_enrichment.tomba_api_key!=undefined && props.email_enrichment.tomba_secret_key!=undefined){prospectsafari_email_enrichment=props.email_enrichment;}
    }
    return(
      <div style={{position:'relative', width:'100%', height:'100vh'}}>
      {(props.current_list.total=='empty')?null:<Loader loading={(props.current_list.ids.length==0 || company==undefined)?true:false}/>}
      {(company==undefined || list==undefined)?
        <Fragment>
        <div id='pv_wiz_3' style={{position:'absolute', bottom:'0px', width:'calc(100% - 2px)', zIndex:'10000', boxShadow:"4px 8px 5px 10px #888888"}}></div>
        <div id='pv_wiz_4' style={{position:'absolute', bottom:'0px', width:'calc(100% - 2px)', zIndex:'10000', boxShadow:"4px 8px 5px 10px #888888"}}></div>
        <div id='pv_wiz_5' style={{position:'absolute', bottom:'0px', width:'calc(100% - 2px)', zIndex:'10000', boxShadow:"4px 8px 5px 10px #888888"}}></div>
        </Fragment>
        :
        <Form
          onSubmit={onSubmit}
          initialValues={JSON.parse(JSON.stringify(company))}
          mutators={{
            ...arrayMutators
          }}
          >
          {form_props =>{
            form_props_ref.current=form_props;
            form_props.form.setConfig('keepDirtyOnReinitialize', true);
            return(
        <form onSubmit={form_props.handleSubmit}>
      <div style={{position:'absolute', width:'100%', height:'100%', top:'0px', paddingBottom:'0px'}}>
      <div style={{width:'100%', height:'100%', overflowY:'scroll'}}>
      <Grid container>
      <Grid id='pv_wiz_4' item xs={12} md={(props.bigWebsite==true)?12:6} style={{position:'relative'}}>
      <Flick {...props} setGoToNumber={(func)=>{goToNumber.current=func}} data={props.current_list.ids} dataIndex={dataIndex} setDataIndex={(index, final=false)=>{console.log('FLICK SET INDEX'); form_props.form.submit(); setDataIndex(index, final);}}/>
      <div style={{width:'100%', position:'relative', height:'calc(100vh - 160px)', overflowY:'scroll', paddingTop:'10px'}}>
      <Display {...props} prospectsafari_email_enrichment={prospectsafari_email_enrichment}  entity={entity} setAddOnMarketingFunc={(func)=>{setAddOnMarketing.current=func;}} setAddOnMarketing={setAddOnMarketing} setOpenCmapFunction={(func)=>{openCmapFunction.current=func;}} company={company} filterOnContact={(contact_id)=>{if(filterOnContact.current!=undefined){filterOnContact.current(contact_id)}}} filterOnDeal={(deal_id)=>{if(filterOnDeal.current!=undefined){filterOnDeal.current(deal_id)}}} workspace_data={props.workspace_data} setExtraUrl={props.setExtraUrl} bigWebsite={props.bigWebsite} callPhone={call_phone.current} sendEmail={email.current} sendMessage={send_message.current} writeNote={write_note.current} scheduleTask={schedule_task.current} scheduleMeeting={schedule_meeting.current}/>
      </div>
      </Grid>
      <Grid id='pv_wiz_5' item xs={12} md={(props.bigWebsite==true)?12:6}><Timeline me={props.me} prospectsafari_email_enrichment={prospectsafari_email_enrichment} entity={entity} setAddOnMarketing={setAddOnMarketing} countries={props.countries} nextProspect={()=>{console.log('NEXT PROSPECT'); if(dataIndex+1==props.current_list.ids.length){goToNumber.current(1)}else{setDataIndex(dataIndex + 1)}}} workspace_data={props.workspace_data} workspace={props.workspace_data} company={company} openDeal={openDeal} setFilterOnDeal={(func)=>{filterOnDeal.current=func}} setFilterOnContact={(func)=>{filterOnContact.current=func}} setPhoneCallFunction={(func)=>{call_phone.current=func}} setEmailFunction={(func)=>{email.current=func}} setMessageFunction={(func)=>{send_message.current=func;}} setNoteFunction={(func)=>{write_note.current=func}} setTaskFunction={(func)=>{schedule_task.current=func}} setMeetingFunction={(func)=>{schedule_meeting.current=func;}}/></Grid>
      </Grid>
      </div>
      </div>
      <Bottom_bar {...props} company={company} dataIndex={dataIndex} openDeal={openDeal} resetBottomBar={(func)=>{reset_bottom_bar.current=func}} deleteCompanies={props.deleteCompanies} workspace_data={props.workspace_data} submit={(previous=false)=>{console.log('HERE 2'); if(previous==true){if(dataIndex!=0){setDataIndex(dataIndex-1);}}else{form_props.form.submit(); if((props.current_list.current_index + 1)!=props.current_list.total){setDataIndex(dataIndex+1);}else{props.reset_current_list(); props.index_companies({list_id:(props.match.params.list=='all')?undefined:props.match.params.list, page:0});}}}}/>
      </form>
      )}}
        </Form>
      }
      </div>
    )
}


function Bottom_bar(props){
  const[bottom_bar, setBottomBar]=useState('decisions');
  const[task_mode, setTaskMode]=useState(false);

  let filterr={}; let ff=window.location.pathname.split('/f/'); if(ff.length>1){filterr=JSON.parse(atob(decodeURIComponent(ff[1].split('/')[0])))}
  if((filterr.queue_id!=undefined || filterr.entity=='tasks') && bottom_bar=='decisions'){setBottomBar('tasks');}
  if((filterr.queue_id!=undefined || filterr.entity=='tasks')){if(task_mode==false){setTaskMode(true);}}else{if(task_mode==true){setTaskMode(false);}}
  if(props.workspace==undefined){return null;}
  if(bottom_bar=='tasks'){return(<Task_view {...props} setBottomBar={setBottomBar}/>)}
  else if(bottom_bar=='decisions'){return(<Categorize {...props} setBottomBar={setBottomBar}/>)}
  else if(bottom_bar=='scorecard'){return(<Scorecard {...props} task_mode={task_mode} setBottomBar={setBottomBar}/>)}
}



function Flick(props){
      const[page, setPage]=useState();
      const[edit_mode, setEditMode]=useState(false);
      const[clickable_arrows, setClickableArrows]=useState(true);
      let timeout=useRef();
      let filt=useRef();
      let quer=useRef();
      filt.current=props.current_list.filter;
      quer.current=props.current_list.query;
      useEffect(()=>{
        props.setGoToNumber(goToNumber);
        setClickableArrows(false)
        clearTimeout(timeout.current);
        timeout.current=setTimeout(function(){setClickableArrows(true);}, 1000);
      },[props.dataIndex])

      function goToNumber(num){
        let fic=filt.current; let quc=quer.current;
        if(num<props.current_list.total+1){props.reset_current_list(); props.setDataIndex(Number(num) - 1, true); props.index_companies({list_id:(props.match.params.list=='all')?undefined:props.match.params.list, filter:fic, query:quc, page:((Number(num) - 1)>props.current_list.rowsPerPage)?(Math.floor((Number(num) -1)/props.current_list.rowsPerPage))+1:undefined}); setEditMode(false);}
      }
      let pathname=window.location.pathname; let filter=undefined; let ff=pathname.split('/f/'); if(ff.length>1){filter=atob(decodeURIComponent(ff[1].split('/')[0]))}
      let list_name=''; if(filter!=undefined && props.lists!=undefined){
        filter=JSON.parse(filter);
        if(filter.list_id!=undefined && props.lists[filter.list_id]!=undefined){list_name=props.lists[filter.list_id].name}else if(filter.queue_id!=undefined && props.queue_data!=undefined){list_name=(filter.queue_id=='all')?'All queues':(props.queue_data[filter.queue_id]==undefined)?'':props.queue_data[filter.queue_id].name}
        if(filter.saved_filter_name!=undefined){list_name='View: '+filter.saved_filter_name+' ('+((list_name=='All queues' || list_name=='')?'all':list_name)+')';}
      }

      return(
        <Fragment>
        <div style={{height:'30px', marginTop:'30px', marginBottom:'10px'}}/>
          <Paper style={{boxShadow:"2px 5px 5px #888888", width:'calc(100% - 20px)', right:'10px', position:'absolute', zIndex:'100000', top:'30px', height:'55px'}}>
                  <Grid container style={{width:'100%'}}>
                        <Grid item xs={3} style={{display:'flex', justifyContent:'center', alignItems:'center'}}><IconButton disabled={!clickable_arrows} onClick={()=>{setEditMode(false); if(props.dataIndex==0){goToNumber(props.current_list.total)}else{props.setDataIndex(props.dataIndex - 1)}}}><ArrowBackIcon/></IconButton></Grid>
                        <Grid item xs={6} style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                  {(edit_mode==true)?<Fragment><span><form onSubmit={(e)=>{e.preventDefault(); e.stopPropagation(); goToNumber(page)}}><TextField size='small' type="text" pattern="[0-9]{6}" style={{width:'30px'}} value={page} onChange={(e)=>{setPage(e.target.value)}}/></form></span><span>{' of '+props.current_list.total}</span></Fragment>:<Typography style={{cursor:'pointer'}} onClick={()=>{setPage(props.current_list.current_index+1); setEditMode(true)}}>{props.current_list.current_index+1 + " of "+props.current_list.total}</Typography>}
                  </Grid><Grid item xs={3} style={{display:'flex', justifyContent:'center', alignItems:'center'}}><IconButton disabled={!clickable_arrows} onClick={()=>{setEditMode(false); if(props.dataIndex+1==props.data.length){goToNumber(1)}else{props.setDataIndex(props.dataIndex + 1)}}}><ArrowForwardIcon/></IconButton></Grid></Grid>
                  <div style={{position:'relative', display:'flex', width:'100%', alignItems:'center', marginTop:'-15px'}}><Typography style={{width:'calc(100% - 40px)', marginLeft:'20px', overflow:'hidden', textAlign:'center'}} variant='caption' color='primary'>{list_name}</Typography></div>
        </Paper>
        </Fragment>
      )
}







export default connect(ss, dd)(Data);

function ss(state){
  return{
    subscriptions:state.account.subscriptions,
    email_enrichment:state.integrations.email_enrichment,
    refresh_companies:state.companies.refresh,
    ti_loading:state.companies.timeline_items_loading,
    ti_refresh:state.companies.timeline_items_refresh,
    company_loading:state.companies.company_loading,
    companies:state.companies.data,
    tasks:state.companies.task_data,
    lists:state.lists.data,
    queue_data:state.lists.queue_data
  }
}

function dd(dispatch){
  return{
    reset_current_list:()=>{dispatch({type:'RESET_CURRENT_LIST'})},
    modify_index_companies:(info)=>{dispatch({type:'REQUEST_INDEX_COMPANIES_MODIFY', val:info})},
    getCompany:(info)=>{dispatch({type:'REQUEST_COMPANY_GET', ...info})},
    index_companies:(info)=>{dispatch({type:'REQUEST_INDEX_COMPANIES', ...info})},
    updateCompany:(id,params, company)=>{dispatch({type:'REQUEST_COMPANY_UPDATE', id:id, payload:params, original_company:company})},
    deleteCompanies:(payload)=>{dispatch({type:'REQUEST_DELETE_COMPANIES', payload:payload});}
  }
}
